import { Search } from "component-library";
import type { ChangeFilters } from "hoc/withJobsFilter/withJobsFilter";
import {
  FilterType,
  IFilterModel,
} from "hoc/withJobsFilter/withJobsFilter.config";

export function EmptyFunction() {}

export const DEFAULT_JOBS_FEEED = {
  PATHNAME: "/jobs/matching-my-filters",
  PAGENUMBER: "1",
  BREAKDOWN_ID: "",
  IS_BACK_TO_JOBS_FEED: false,
};

export const MATCHING_MY_FILTER_SEARCH = "matchingMyFilterSearch";

export const ALL_OPPORTUNITIES_SEARCH = "allOpportunitiesSearch";

export const CLIENT_ALERTS_SEARCH = "clientAlertsSearch";

export const ALL_PAID_SEARCH = "allPaidSearch";

export interface IPersistSearchAndResetJobsFeedStorage {
  setJobsFeedStorage: (
    pathName: string,
    pageNumber: string,
    breakdownId: string,
    isBackToJobsFeed: boolean
  ) => void;
  pathName: string;
  tab: string;
  search: string | undefined;
}

export const persistSearch = (tab: string, search?: string) => {
  if (search) {
    sessionStorage.setItem(tab, search);
  } else {
    sessionStorage.removeItem(tab);
  }
};

export const persistSearchAndResetJobsFeedStorage = (
  input: IPersistSearchAndResetJobsFeedStorage
) => {
  const { setJobsFeedStorage, pathName, tab, search } = input;

  setJobsFeedStorage(
    pathName,
    DEFAULT_JOBS_FEEED.PAGENUMBER,
    DEFAULT_JOBS_FEEED.BREAKDOWN_ID,
    DEFAULT_JOBS_FEEED.IS_BACK_TO_JOBS_FEED
  );

  persistSearch(tab, search);
};

export const searchRefClear = (searchRef: React.RefObject<Search>) => {
  searchRef.current?.setState({
    searchString: "",
    isInitialValueSet: true,
  });
};

export const initSearch = (
  tab: string,
  pageNum: string,
  changeFilters: ChangeFilters
) => {
  const savedSearch = sessionStorage.getItem(tab);

  if (savedSearch) {
    const restoredPage = Number(pageNum);
    const pageNumber =
      Number.isFinite(restoredPage) && restoredPage > 0
        ? restoredPage
        : Number(DEFAULT_JOBS_FEEED.PAGENUMBER);

    changeFilters({
      [FilterType.TextFilter]: savedSearch,
      [FilterType.PageNumber]: pageNumber,
    });
  }
};

export const getInitialValue = (filterValues: IFilterModel) =>
  filterValues[FilterType.TextFilter] ?? "";
